import { render, staticRenderFns } from "./orderComplete.vue?vue&type=template&id=1fbb0d4e&"
import script from "./orderComplete.vue?vue&type=script&lang=ts&"
export * from "./orderComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports